import AppNavbar from "@/components/layout/AppNavbar";
import Footer from "@/components/layout/Footer";
import { SUPPORT_EMAIL } from "@/shared/constants/support";

import { Col } from "react-bootstrap";
// import 'bootstrap/dist/css/bootstrap.min.css';
import "@/assets/css/style.css";



function Privacy() {

  return (
    <>
      <AppNavbar />
      <main className="container-lg nav-padding">
        <Col lg={{ span: 8, offset: 2 }} className="py-5">
          <h2 className="mb-4">Privacy Policy</h2>
          <p>
            Welcome to Favluv, a social networking platform owned and operated
            by Wishcan Inc. Your privacy is important to us, and this Privacy
            Policy outlines how we collect, use, share, and protect your
            information. By using Favluv, you agree to the terms of this Privacy
            Policy.
          </p>

          <h3 className="mt-4 mb-3">1. Information We Collect</h3>

          <h4 className="mt-3 mb-2">a. Information You Provide to Us</h4>
          <ul>
            <li>
              <strong>Account Information:</strong> Name, email address, phone
              number, username, password, and profile details.
            </li>
            <li>
              <strong>Content:</strong> Photos, videos, posts, comments, and any
              other content you share on Favluv.
            </li>
            <li>
              <strong>Communications:</strong> Messages, feedback, and
              interactions with customer support.
            </li>
          </ul>

          <h4 className="mt-3 mb-2">b. Information We Collect Automatically</h4>
          <ul>
            <li>
              <strong>Usage Data:</strong> Your interactions with Favluv, such
              as features you use, content you view, and time spent on the
              platform.
            </li>
            <li>
              <strong>Device Information:</strong> Device type, operating
              system, browser type, and IP address.
            </li>
            <li>
              <strong>Cookies and Similar Technologies:</strong> Tracking
              technologies that collect data about your browsing activities.
            </li>
          </ul>

          <h4 className="mt-3 mb-2">c. Information from Third Parties</h4>
          <ul>
            <li>
              <strong>Social Media:</strong> If you connect your account to
              third-party platforms (e.g., Facebook, Google), we may receive
              certain profile and account details.
            </li>
            <li>
              <strong>Advertising Partners:</strong> Data about your
              interactions with ads and promotions.
            </li>
          </ul>

          <h3 className="mt-4 mb-3">2. How We Use Your Information</h3>
          <p>We use your information to:</p>
          <ul>
            <li>Provide, operate, and personalize Favluv services.</li>
            <li>Process account registration and authenticate users.</li>
            <li>Facilitate social interactions and content sharing.</li>
            <li>Analyze usage trends to improve platform functionality.</li>
            <li>
              Communicate updates, promotional offers, and support information.
            </li>
            <li>Display relevant ads and recommendations.</li>
            <li>
              Comply with legal obligations and enforce our Terms of Service.
            </li>
          </ul>

          <h3 className="mt-4 mb-3">3. How We Share Your Information</h3>

          <h4 className="mt-3 mb-2">a. With Other Users</h4>
          <p>
            Public posts, profile information, and content you choose to share
            will be visible to other users based on your privacy settings.
          </p>

          <h4 className="mt-3 mb-2">b. With Service Providers</h4>
          <p>
            Third-party vendors that support our platform, such as hosting,
            analytics, payment processing, and customer service providers.
          </p>

          <h4 className="mt-3 mb-2">c. With Business Partners</h4>
          <p>
            Advertisers and marketing partners for delivering personalized ads
            and offers.
          </p>

          <h4 className="mt-3 mb-2">d. For Legal Reasons</h4>
          <p>
            To comply with legal obligations, respond to lawful requests, and
            protect the rights, safety, and property of Wishcan Inc. and others.
          </p>

          <h4 className="mt-3 mb-2">e. In Case of Business Transfer</h4>
          <p>
            If Wishcan Inc. undergoes a merger, acquisition, or sale, your
            information may be transferred to the new entity.
          </p>

          <h3 className="mt-4 mb-3">4. Your Choices and Controls</h3>
          <p>We provide tools to help you manage your privacy:</p>
          <ul>
            <li>
              <strong>Privacy Settings:</strong> Control who can see your
              profile and posts.
            </li>
            <li>
              <strong>Account Access:</strong> Update or delete your account
              information.
            </li>
            <li>
              <strong>Opt-Out:</strong> Manage preferences for promotional
              communications and targeted ads.
            </li>
            <li>
              <strong>Cookies:</strong> Adjust browser or device settings to
              block cookies.
            </li>
          </ul>

          <h3 className="mt-4 mb-3">5. Data Retention</h3>
          <p>
            We retain your information for as long as necessary to provide our
            services or comply with legal obligations. When no longer needed,
            your data will be deleted or anonymized.
          </p>

          <h3 className="mt-4 mb-3">6. Data Security</h3>
          <p>
            We use industry-standard measures to protect your data, including
            encryption, secure servers, and access controls. However, no method
            of transmission or storage is completely secure, and we cannot
            guarantee absolute security.
          </p>

          <h3 className="mt-4 mb-3">7. Children's Privacy</h3>
          <p>
            Favluv is not intended for children under the age of 13. We do not
            knowingly collect information from children. If we learn that a
            child’s data has been collected, we will take steps to delete it.
          </p>

          <h3 className="mt-4 mb-3">8. International Users</h3>
          <p>
            By using Favluv, you consent to your information being transferred
            to and processed in countries where we operate. We comply with
            applicable data protection laws in these regions.
          </p>

          <h3 className="mt-4 mb-3">9. Changes to This Privacy Policy</h3>
          <p>
            We may update this Privacy Policy from time to time. We will notify
            you of significant changes by posting a notice on Favluv or
            contacting you directly. Your continued use of the platform
            constitutes acceptance of the updated policy.
          </p>

          <h3 className="mt-4 mb-3">10. Contact Us</h3>
          <p>
            If you have questions or concerns about this Privacy Policy or our
            data practices, please contact us at:
          </p>
          <address>
            <address>
              <strong>Wishcan Inc.</strong>
              <br />
              2233 Wind River Ln
              <br />
              Rowland Heights, CA, 91748
              <br />
              Email:{" "}
              <span className="email">
                {SUPPORT_EMAIL}
              </span>
            </address>
          </address>
        </Col>
      </main>
      <Footer />
    </>
  );
}

export default Privacy;
